import React from 'react';
import { GIFS, PNGS, SVGS } from '../../assets';
import './deploy-agent-advantages.scss';
import { WabaRequirementsCard } from '../waba-setup/waba-requirements-card/waba-requirements-card';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';

interface WabaPreRequirementsProps {
  onBackClick: () => void;
  onContinueClick: () => void;
  onSkipClick: () => void;
}

export const DeployAgentBotAdvantages: React.FC<WabaPreRequirementsProps> = ({
  onBackClick,
  onContinueClick,
  onSkipClick,
}) => {
  const requirements = [
    {
      icon: PNGS.BotAdvantage1,
      heading: '24/7 Instant Customer Support',
      description:
        'Responds to customer queries anytime, without human delay. Handles FAQs, product queries, order status, etc.',
    },
    {
      icon: PNGS.BotAdvantage2,
      heading: 'Trained on Your Product Catalog',
      description:
        'Answers customer questions using your product details, brochures, price lists, and schemes.',
    },
    {
      icon: PNGS.BotAdvantage3,
      heading: 'Automated Order Taking',
      description:
        'A valid website and business email help Meta verify your business faster and improve approval chances.',
    },
  ];
  return (
    <div className="deploy-agent-advantages">
      <div className="deploy-agent-advantages-container">
        <div className="deploy-agent-advantages-container-header">
          <img
            src={GIFS.ExcitedRobot}
            alt=""
            className="deploy-agent-advantages-container-header-icon"
          />
          <div className="deploy-agent-advantages-container-header-text">
            <span className="deploy-agent-advantages-container-header-text-heading primary-font-bold">
              Advantages of Bot Agent!
            </span>
            <span className="deploy-agent-advantages-container-header-text-description primary-font-regular">
              Setup process for getting the ZöTok agent on your WhatsApp
              Business account.
            </span>
          </div>
        </div>
        <div className="deploy-agent-advantages-container-body">
          {requirements.map((item) => {
            return (
              <WabaRequirementsCard
                icon={item.icon}
                heading={item.heading}
                description={item.description}
              />
            );
          })}
        </div>
      </div>
      <div className="deploy-agent-advantages-footer">
        <div className="deploy-agent-advantages-footer-buttons">
          <ZoButton
            onClick={onBackClick}
            label={'Back'}
            startIcon={<img src={SVGS.LeftArrowBlue} alt="" />}
            className="deploy-agent-advantages-footer-buttons-back"
          />
          <ZoButton
            onClick={onContinueClick}
            label={'Continue'}
            endIcon={<img src={SVGS.RightArrowIcon} alt="" />}
            className="deploy-agent-advantages-footer-buttons-continue"
          />
        </div>
      </div>
    </div>
  );
};
